import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withModalMessage from 'common/components/hoc-helpers/withModalMessage';
import FormForgotPassword from './FormForgotPassword';

export default compose(
  withRouter,
  withModalMessage
)(FormForgotPassword);
